import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { chats, messages, send } from "../../api/Support"

/* Widgets */
import { Layout } from "../Table"

/* Components */
import { Avatar } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Sweet Alert */
import Swal from "sweetalert2"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* Widget Chat */
class Chat extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,

            /* Chat */
            chatStatus: "loading",
            chats: [],

            /* Messages */
            active: null,
            messageStatus: "loading",
            messages: [],

            /* Bottom Input */
            message: "",
            sending: false,
        }
    }

    /* Open */
    open = () => {

        /* Open Modal */
        this.setState({ visible: true })

        /* Load Action */
        this.load()

        /* Register Socket Events */
        this.socketEvents()

    }

    /* Close */
    close = () => {

        /* Fields */
        const { updateBadge } = this.props

        /* Clear */
        this.setState({
            visible: false,
            chatStatus: "loading",
            chats: [],
            active: null,
            messageStatus: "loading",
            messages: [],
            message: "",
            sending: false,
        })

        /* Update Badge */
        updateBadge()
    }

    /* Socket Events */
    socketEvents = () => {

        /* Fields */
        const { socket } = this.props

        /* On Admin Answer */
        socket.on("adminSupportAnswer", (data) => {

            /* Fields */
            const { active } = this.state

            /* Load Messages */
            if (active && active.player === data.player) {
                this.messages()
            }

            /* Load Chats */
            this.load()

        })

        /* On Support Message */
        socket.on("supportMessage", (data) => {

            /* Fields */
            const { active } = this.state

            /* Load Messages */
            if (active && active.player === data.player) {
                this.messages()
            }

            /* Load Chats */
            this.load()

        })

    }


    /* Load Action */
    load = (reload = false) => {

        /* Reload */
        if (reload) {
            this.setState({ chatStatus: "loading", chats: [] })
        }

        /* Load Chats */
        chats().then((response) => {
            if (response.status === 200) {
                this.setState({ chatStatus: "ok", chats: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ chatStatus: "permission", chats: [] })
            }
            else if (response.status === 498) {
                this.setState({ chatStatus: "key", chats: [] })
            }
            else {
                this.setState({ chatStatus: "error", chats: [] })
            }
        }).catch(() => {
            this.setState({ chatStatus: "network", chats: [] })
        })
    }


    /* Load Message */
    messages = (reload = false) => {

        /* Fields */
        const { active } = this.state

        /* Check Active */
        if (!active) {
            return
        }

        /* Reload */
        if (reload) {
            this.setState({ messageStatus: "loading", messages: [] })
        }

        /* Load Messages */
        messages({ chatID: active.id }).then((response) => {
            if (response.status === 200) {
                this.setState({ messageStatus: "ok", messages: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ messageStatus: "permission", messages: [] })
            }
            else if (response.status === 498) {
                this.setState({ messageStatus: "key", messages: [] })
            }
            else {
                this.setState({ messageStatus: "error", messages: [] })
            }
        }).catch(() => {
            this.setState({ messageStatus: "network", messages: [] })
        })

    }


    /* Send Action */
    send = () => {

        /* Fields */
        const { active, message } = this.state
        const { socket } = this.props

        /* Check Message */
        if (!message || message.length === 0) {
            return
        }

        /* Check Active */
        if (!active) {
            return
        }

        /* Start Sending */
        this.setState({ sending: true })

        /* Send Message */
        send({ message, chatID: active.id }).then((response) => {
            if (response.status === 200) {

                /* Load Action */
                this.load()

                /* Set Message */
                const { messages: _messages } = this.state
                _messages.unshift(response.data)
                this.setState({ _messages })

                /* Emit Answer */
                socket.emit("adminSupportAnswer", { player: active.player, table: active.table, message, type: "admin", name: "Служба поддержки" })
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ sending: false, message: "" })
            this._textarea.style.height = "40px"
        })

    }

    /* Handle Change */
    handleChange = (event) => {
        this.setState({ message: event.target.value })
        this._textarea.style.height = "auto"
        this._textarea.style.height = `${this._textarea.scrollHeight}px`
    }


    /* Draw Button */
    _button = () => {

        /* Fields */
        const { sending } = this.state

        /* Sending */
        if (sending) {
            return (
                <div className="chat--message-button loading">
                    <LoadingOutlined />
                </div>
            )
        }

        return (
            <div onClick={() => this.send()} className="chat--message-button">
                <img src="/images/send.png" alt="Send" />
            </div>
        )
    }

    /* Draw Input */
    _input = () => {

        /* Fields */
        const { message } = this.state

        return (
            <div className="chat--message-bottom">

                <textarea
                    ref={(ref) => this._textarea = ref}
                    value={message}
                    onChange={this.handleChange}
                    rows={1}
                    placeholder={t("support.inputPlaceholder")}
                    className="chat--input"
                />

                {/* Draw Button */}
                {this._button()}

            </div>
        )
    }

    /* Open Messages */
    openMessages = (item) => {

        /* Fields */
        const { chats } = this.state

        /* Get Index */
        const index = chats.findIndex((e) => parseInt(e.id) === parseInt(item.id))

        /* Check Index */
        if (index > -1) {
            chats[index].unread = 0
        }

        /* Save */
        this.setState({ active: item, chats }, () => this.messages(true))
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { chatStatus, chats, active, messageStatus, messages } = this.state

        /* Layout */
        if (chatStatus !== "ok") {
            return <Layout status={chatStatus} reload={() => this.load(true)} />
        }

        /* Empty Layout */
        if (chats.length === 0) {
            return <Layout status="empty" type="messages" />
        }

        /* Draw Messages */
        if (active) {

            /* Layout */
            if (messageStatus !== "ok") {
                return (
                    <div className="chat--message-container">

                        <div className="chat--messages-layout">
                            <Layout status={messageStatus} reload={() => this.messages(true)} />
                        </div>

                        {/* Draw Input */}
                        {this._input()}

                    </div>
                )
            }

            /* Layout */
            if (messages.length === 0) {
                return (
                    <div className="chat--message-container">

                        <div className="chat--messages-layout">
                            <Layout status="empty" type="messages" />
                        </div>

                        {/* Draw Input */}
                        {this._input()}

                    </div>
                )
            }

            return (
                <div className="chat--message-container">

                    <div className="chat--messages">
                        {messages.map((item, index) =>
                            <div className={`chat--message ${item.type}`} key={`${index}`}>
                                <div className="chat--message-type">{utils.checkValue(item.type, "-") === "player" ? t("support.playerType") : t("support.adminType")}</div>
                                <div className="chat--message-name">{utils.checkValue(item.name, "-")}</div>
                                <div className="chat--message-message">{utils.checkValue(item.message, "...")}</div>
                                <div className="chat--message-date">
                                    {moment(item.createdAt).format("HH:mm")}
                                    <span>{moment(item.createdAt).format("Do MMM")}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Draw Input */}
                    {this._input()}

                </div>
            )
        }

        return (
            <div className="chat--container">
                {chats.map((item, index) =>
                    <div onClick={() => this.openMessages(item)} className="chat--element" key={`${index}`}>

                        <div className="chat--element-ava">
                            <Avatar uri={utils.ava(item.ava)} size={70} />
                        </div>

                        <div className="chat--element-text">
                            <div className="chat--element-text-name">{utils.checkValue(item.user, "")}</div>
                            <div className="chat--element-text-player">{utils.checkValue(item.player, "")}</div>
                            <div className="chat--element-text-game">{utils.checkValue(item.game, "")}</div>
                            <div className="chat--element-text-message">{utils.checkValue(item.message, "...")}</div>
                        </div>

                        <div className="chat--element-more">
                            <div className="chat--element-date">
                                {moment(item.lastUpdated).format("HH:mm")}
                                <span>{moment(item.lastUpdated).format("Do MMM")}</span>
                            </div>
                            {utils.checkValue(item.unread, 0) > 0 && <div className="chat--element-badge">{utils.checkValue(item.unread, 0)}</div>}
                        </div>

                    </div>
                )}
            </div>
        )
    }

    /* Draw Left */
    _left = () => {

        /* Fields */
        const { active } = this.state

        /* Check Active */
        if (active) {
            return (
                <div onClick={() => this.setState({ active: null, message: "", messageStatus: "loading", messages: [] })} className="chat--modal-close">
                    <img src="/images/left-arrow.png" alt="Left" />
                </div>
            )
        }
    }

    /* Draw Title */
    _title = () => {

        /* Fields */
        const { active } = this.state

        /* Check Active */
        if (active) {
            return (
                <div className="chat--modal-header-container">
                    <Avatar uri={utils.ava(active.ava)} size={40} />
                    <div className="chat--modal-header-title">
                        <h2>{utils.checkValue(active.user, "")}</h2>
                        <span>{utils.checkValue(active.player, "")}</span>
                    </div>
                </div>
            )
        }

        return <h2>{t("support.title")}</h2>
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="chat--modal"
                overlayClassName="chat--overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="chat--modal-header">
                    {this._left()}
                    {this._title()}
                    <div onClick={() => this.close()} className="chat--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="chat--modal-container">
                    {this._content()}
                </div>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Chat)